const getUserEmailValue = () => {
  const inputElement = document.getElementById('userEmailInput')
  return inputElement?.value
}

export default getUserEmailValue
